import type { GanttLocalProps } from "./types-gantt-local";
import { useGanttLocal } from "./use-gantt-local";
import { GanttLocalView } from "./view-gantt-local";

export function GanttLocal(props: GanttLocalProps) {
  const vm = useGanttLocal(props);

  return <GanttLocalView {...vm} />;
}

export type * from "./types-gantt-local";
